import { Button } from '@voll-intelligence/ui-kit/ui/button';

import type { GenUiDispatch } from '../../../shared/ui/action.js';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';

/**
 * O atalho para a folha de pedido da 99 (#6889): o título e o botão que a abre
 * (`open-ride99`). `readOnly` (thread do operador, conversa encerrada) mostra só o título.
 */
export function Ride99LinkCard({
  readOnly = false,
  dispatch,
}: Readonly<{ readOnly?: boolean; dispatch: GenUiDispatch }>) {
  const { t } = useGenUiI18n();
  return (
    <div className="flex w-full items-center justify-between gap-3 rounded-md border border-border bg-card px-4 py-3 shadow-(--shadow-elevation)">
      <span className="text-ui min-w-0 text-foreground">{t('ride99Link.title')}</span>
      {!readOnly && (
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => {
            dispatch({ type: 'open-ride99' });
          }}
        >
          {t('ride99Link.cta')}
        </Button>
      )}
    </div>
  );
}
